import React from 'react';
import {
  compose,
  withProps,
  setDisplayName,
} from 'recompose';
import reactCSS from 'reactcss';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import CascadingFormattedMessage from '@ux/cascading-formatted-message';
import { headingXs, footnote } from '@ux/type-size';
import { whenTrue, nuller, allPass } from '../../../crosscutting/capra';
import { gu2px } from '@ux/theme-utils';
import { getStyles } from '@ux/style-utils';
import Badge, { Kind as BadgeKind } from '@ux/badge';
import * as r from 'ramda';

const stylesheet = ({
  theme,
}) => {
  return {
    default: {
      root: {
        ...footnote(theme.typography),
        color: theme.palette.grey04,
      },
      oldPrice: {
        textDecoration: 'line-through',
        ...footnote(theme.typography),
        marginLeft: gu2px(1, theme.spacing),
        color: theme.palette.grey08,
      },
      price: {
        fontWeight: 600,
        ...headingXs(theme.typography),
        color: theme.palette.secondary,
      },
    },
    promo: {
      price: {
        // color: theme.palette.highlight,
      },
    },
  };
};

const stylesheetToStyles = (stylesheet, props) => reactCSS(stylesheet, {
  promo: props.isPromo,
});

const PureOldPrice = r.ifElse(
  r.propEq('isPromo', true),
  ({
    styles,
    intlNamespace,
    price,
    currency,
  }) => (
    <span style={styles.oldPrice}>
      <FormattedMessage
        id={`dst.${intlNamespace}.oldPrice`}
        values={{
          price: (
            <FormattedNumber
              value={price}
              // eslint-disable-next-line react/style-prop-object
              style="currency"
              currency={currency}
            />
          ),
        }}
      />
    </span>
  ),
  nuller,
);

export const DomainOldPrice = r.compose(
  setDisplayName('DomainOldPrice')
)(PureOldPrice);

export const PureDomainPrice = ({
  theme,
  styles,
  price,
  oldPrice,
  currency,
  intlNamespace,
  priceText,
  isPromo,
  isMinSm,
  hasLegal,
}) => (
  <div style={styles.root}>
    {r.when(
      allPass,
      r.always(
        <Badge
          kind={BadgeKind.HIGHLIGHT}
          theme={theme}
        >
          <FormattedMessage id={`dst.${intlNamespace}.sale`}/>
        </Badge>
      )
    )([ isPromo, r.not(isMinSm) ])}
    <CascadingFormattedMessage
      cascade={priceText}
      values={{
        price: (
          <span style={styles.price}>
            <FormattedNumber
              value={price}
              // eslint-disable-next-line react/style-prop-object
              style="currency"
              currency={currency}
            />
            {whenTrue(
              r.always('*'),
              hasLegal,
            )}
          </span>
        ),
      }}
    />
    <DomainOldPrice
      theme={theme}
      styles={styles}
      price={oldPrice}
      currency={currency}
      intlNamespace={intlNamespace}
      isPromo={isPromo}
    />
  </div>
);

export const enhance = compose(
  setDisplayName('DomainPrice'),
  withProps((ownerProps) => ({
    styles: getStyles(stylesheet, stylesheetToStyles, ownerProps),
    priceText: r.ifElse(
      r.propEq('isPromo', true),
      r.always([
        {
          id: `dst.${ownerProps.intlNamespace}.promo.price`,
        },
        {
          id: `dst.${ownerProps.intlNamespace}.price`,
        },
      ]),
      r.always([
        {
          id: `dst.${ownerProps.intlNamespace}.price`,
        },
      ]),
    )(ownerProps),
  })),
);

export default enhance(PureDomainPrice);
